import { SEO } from 'app/components/SEO'
import { Props as StructuredDataProps } from 'app/components/StructuredData'
import { Props as FooterProps } from 'app/containers/Footer'
import { Props as HeaderProps } from 'app/containers/Header'
import { PageProps } from 'gatsby'
import React, { memo, Suspense } from 'react'

const Header = lazyComponent(() => import('app/containers/Header'))
const Footer = lazyComponent(() => import('app/containers/Footer'))
const Hero = lazyComponent(() => import('app/components/Hero/Advanced'))
const Intro = lazyComponent(() => import('app/components/Intro/One'))
const RoomsPreview = lazyComponent(() => import('app/components/Rooms/Preview'))
const ServicesPreview = lazyComponent(
  () => import('app/components/Services/Preview'),
)
const VisualService = lazyComponent(
  () => import('app/components/Visual/Service'),
)
const Location = lazyComponent(() => import('app/components/Location'))
const ExperiencesPreview = lazyComponent(
  () => import('app/components/Experiences/Preview'),
)
const SocialWall = lazyComponent(() => import('app/components/SocialWall'))
const StructuredData = lazyComponent(
  () => import('app/components/StructuredData'),
)

import { lazyComponent } from 'app/utils/customFunctions'

import { Props } from './contents'

export interface PageContext {
  id: string
  languageCode: string
  languagePrefix: string | null
  headerProps?: HeaderProps
  footerProps?: FooterProps
  structuredDataProps?: StructuredDataProps
  type?: 'home'
}

export interface Context extends PageContext {
  props: Props
}

export const Head = ({ pageContext }: PageProps<void, Context>) => {
  const context = pageContext as any

  return <SEO {...context.seoProps} />
}

export default memo(function HomePageTemplate({
  pageContext,
}: PageProps<void, Context>) {
  const context = pageContext as any

  return (
    <Suspense fallback={null}>
      {context.headerProps ? (
        <Header
          flashNewsProps={
            context.flashNewsProps ? context.flashNewsProps : null
          }
          languageCode={context.languageCode}
          languagePrefix={context.languagePrefix}
          pageID={context.id}
          {...context.headerProps}
        />
      ) : null}
      {context.heroProps ? <Hero {...context.heroProps} /> : null}
      {context.introProps ? <Intro {...context.introProps} /> : null}
      {context.roomsPreviewProps ? (
        <RoomsPreview {...context.roomsPreviewProps} />
      ) : null}
      {context.servicesPreviewProps ? (
        <ServicesPreview {...context.servicesPreviewProps} />
      ) : null}
      {context.visualServiceProps ? (
        <VisualService {...context.visualServiceProps} />
      ) : null}
      {context.locationProps ? <Location {...context.locationProps} /> : null}
      {context.experiencesPreviewProps ? (
        <ExperiencesPreview {...context.experiencesPreviewProps} />
      ) : null}
      {context.socialWallProps ? (
        <SocialWall {...context.socialWallProps} />
      ) : null}
      {context.footerProps ? (
        <Footer languageCode={context.languageCode} {...context.footerProps} />
      ) : null}

      {context.structuredDataProps ? (
        <StructuredData
          languageCode={pageContext.languageCode}
          {...context.structuredDataProps}
        />
      ) : null}
    </Suspense>
  )
})
